import TableCellRenderer from '../../../../table/TableCellRenderer'
import $ from 'jquery'
import _ from 'underscore'

function ShowBalanceHistoryCellRenderer() {
    this.constructor = ShowBalanceHistoryCellRenderer;
}

ShowBalanceHistoryCellRenderer.prototype = _.create(TableCellRenderer.prototype, {

    /**
     @param handlers contains functions-handlers as properties
     */
    init: function({
        onClickHandler = () => {},
        onMouseOverHandler = () => {},
        onMouseOutHandler = () => {}
    }) {
        TableCellRenderer.call(this)

        this.onClickHandler = onClickHandler
        this.onMouseOverHandler = onMouseOverHandler
        this.onMouseOutHandler = onMouseOutHandler

        return this
    },

    getCellGeneralClassName: function() {
        //abstract
    },

    getFlagValue: function(value) {
        //abstract
    },

    getCellTooltipText: function() {
        //abstract
    },

    getCellClassName: function(cell) {
        var classes = [this.getCellGeneralClassName()];

        if (!this.getFlagValue(cell.getValue())) {
            classes.push("off");
        }
        else {
            classes.push("on");
        }

        return classes;
    },

    generateContent: function(cell) {
        var value = cell.getValue();
        var cellEl = cell.getCellEl();
        var jQcell = $(cellEl);
        var title = "";
        var content = "";

        if (this.getFlagValue(value)) {

            if (this.onClickHandler)
                cellEl.onclick = () => this.onClickHandler(cell)

            if (this.onMouseOverHandler)
                $(cellEl).hover(e => this.onMouseOverHandler(e), this.onMouseOutHandler)

            jQcell.hover(function() { jQcell.addClass("hovered"); }, function() { jQcell.removeClass("hovered") });

            title = this.getCellTooltipText();

            content += '<div class="ptoHistorySpinnerPlaceholder" style="display: inline-block"></div>';
        }

        cellEl.title = title;
        cellEl.innerHTML = content;
    }
});

export default ShowBalanceHistoryCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/ShowBalanceHistoryCellRenderer.js